import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { ArrowBack } from "@mui/icons-material";
import { Grid2, IconButton, Paper, Tooltip } from "@mui/material";
import { masterDetailsMinHeight, pageBgColor } from "@/utils/theme";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PartDetails } from "./components/PartDetails";
import { partTypeCodes } from "./components/TableParts";
import { useParts } from "./PartsManagerPage";

export const PartsDetailsPage = () => {
	const navigate = useNavigate();

	const { partId } = useParams<{ partId: string }>();
	const [error, setError] = useState("");

	const { data } = useParts({
		partId: Number(partId),
		onError: (error) => setError(error.message),
	});

	const selectedPart = data?.parts?.find(
		(part) => part.PartId === Number(partId),
	);
	const passes = data?.passes ?? [];

	const handleGoBack = () => {
		navigate("/parts-manager");
	};

	return (
		<>
			<HelmetDexteel
				title={`'${selectedPart?.PartName ?? ""}' - ${
					partTypeCodes.find((c) => c.Code === selectedPart?.PartTypeCode)
						?.Name ?? ""
				} - Parts Manager`}
			/>
			<Grid2
				container
				size={{ md: 12 }}
				justifyContent="center"
				sx={{ backgroundColor: pageBgColor, minHeight: masterDetailsMinHeight }}
			>
				<Grid2
					size={{ xs: 12, md: 8 }}
					style={{ display: "flex", marginTop: 20 }}
					alignItems="flex-start"
				>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: 10,
							padding: "0 15px",
							marginBottom: 10,
						}}
					>
						<Tooltip title="Back to Parts Manager">
							<IconButton onClick={handleGoBack} size="small">
								<ArrowBack />
							</IconButton>
						</Tooltip>
					</div>

					<Paper elevation={4} style={{ padding: 20 }}>
						<div style={{ minHeight: "70vh" }}>
							<PartDetails
								showDetails={selectedPart?.PartTypeCode || ""}
								part={selectedPart || null}
								passes={passes}
							/>
						</div>
					</Paper>
				</Grid2>
			</Grid2>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
